// eslint-disable-next-line no-use-before-define
import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import PopupLayout from "../popupLayout/popupLayout";
import StockNotificationSelection from "../stockNotificationSelection/stockNotificationSelection";

const useStyles = makeStyles(theme => ({
  content: {
    display: "flex",
    flexFlow: "column",
    alignItems: "center",
    justifyContent: "center",
    gridRowGap: "32px",
    marginTop: theme.spacing(4),
    marginBottom: "1.5rem",
  },
  description: {
    color: theme.palette.text.disabled,
    textAlign: "left",
    width: "100%",
  },
}));

function ConfirmationPopup({
  title,
  description,
  show,
  top,
  left,
  bottom,
  right,
  onOk,
  onCancel,
  popupRef,
  saveKey,
  cancelKey,
  showLoader,
  iconType,
  content,
  disableSave,
}) {
  const classes = useStyles();

  const ICONS = {
    shoppingCart: require("../../../images/shopping_cart.svg").default,
    subscription: require("../../../images/emailUnread.svg").default,
  };

  return (
    <PopupLayout
      show={show}
      left={left}
      top={top}
      right={right}
      bottom={bottom}
      onOk={onOk}
      onCancel={onCancel}
      popupRef={popupRef}
      saveKey={saveKey}
      cancelKey={cancelKey}
      showLoader={showLoader}
      title={title}
      disableSave={disableSave}
    >
      <div className={classes.content}>
        {iconType && <img src={ICONS[iconType]} alt="" />}
        <Typography className={`${classes.description}`} variant="body1">
          {description}
        </Typography>
        {content &&
          content.contentType &&
          content.contentType === "stockNotification" && (
            <StockNotificationSelection {...content} />
          )}
      </div>
    </PopupLayout>
  );
}

ConfirmationPopup.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  top: PropTypes.number.isRequired,
  left: PropTypes.number.isRequired,
  bottom: PropTypes.number.isRequired,
  right: PropTypes.number.isRequired,
  show: PropTypes.bool,
  onOk: PropTypes.func,
  onCancel: PropTypes.func,
  popupRef: PropTypes.func,
  saveKey: PropTypes.string,
  cancelKey: PropTypes.string,
  showLoader: PropTypes.bool,
  iconType: PropTypes.string,
  content: PropTypes.shape({
    contentType: PropTypes.string,
  }),
  disableSave: PropTypes.bool,
};

ConfirmationPopup.defaultProps = {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onOk: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onCancel: () => {},
  show: false,
  title: "",
  description: "",
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  popupRef: () => {},
  saveKey: "save",
  cancelKey: "cancel",
  content: {},
  disableSave: false,
  showLoader: false,
  iconType: "",
};

export default ConfirmationPopup;
